<template>
    <div
        class="relative w-full sm:w-auto border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600 text-gray-600 focus-within:text-indigo-600 hover:border-indigo-300 transition duration-300">
        <label :class="labelClassList">
            {{ textSearchLabel }}
        </label>
        <input class="block w-full border-0 p-0 bg-white text-gray-700 placeholder-gray-300 focus:ring-0 sm:text-sm"
               type="text"
               v-model="inputText"
               name="filterTextField1"
               @input="$emit('input', $event.target.value)"
               :placeholder="textSearchPlaceholder"
               :style="inputStyles"
               id="filterTextField1">
    </div>
</template>

<script>
export default {
    name: "TextSearchInput",
    props: {
        textSearchLabel: {
            type: String,
            required: false,
            default: "Search"
        },
        labelClassList: {
            type: String,
            required: false,
            default: "absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium select-none"
        },
        textSearchPlaceholder: {
            type: String,
            required: false,
            default: ""
        },
        inputStyles: {
            type: String,
            required: false,
            default: "min-width:300px"
        },
        value: {
            required: true,
        }
    },

    data () {
        return {
            inputText: this.value,
        };
    },

    watch: {
        value (newVal) {
            this.inputText = newVal;
        }
    }
};
</script>

<style scoped>

</style>
